<template >
  <div class="table-grups">
    <table class="table-all">
      <thead class="header-table">
        <tr>
          <th scope="col" class="rigth-especific specific-th">Nome</th>
          <th scope="col" class="rigth-especific specific-th">Cod. Beneficio</th>
          <th scope="col" class="rigth-especific specific-th">Beneficio</th>
          <th scope="col" class="rigth-especific specific-th">Valor</th>
          <th scope="col" class="rigth-especific specific-th">Valor Pago</th>
        </tr>
      </thead>
      <tbody v-for="beneficio in beneficios" :key="beneficio.id">
        <tr>
          <td data-label="nome" class="rigth-especific specific-td">
            {{beneficio.nomeFuncionario}}
            <input class="mask-input-invisible-especific">
          </td>
          <td
            data-label="codigo do beneficio"
            class="rigth-especific specific-td"
          >{{beneficio.beneficioCodigo}}</td>
          <td data-label="beneficio" class="rigth-especific specific-td">
            {{beneficio.beneficio}}
            <div
              style="color:red; margin-top: 14px;"
              v-if="getImprimiValorPrevisto(beneficio)"
            >VALOR A SER REEMBOLDADO</div>
          </td>
          <td data-label="valor" class="rigth-especific specific-td">
            <div>
              <money
                @blur.native="changevalue(beneficio)"
                v-model="beneficio.valor"
                v-bind="money"
                class="mask-input rigth-especific"
                :disabled="aprove || isAlreadyClosed"
              />
            </div>
            <div>
              <div v-if="getImprimiValorPrevisto(beneficio)" style="color:red">
                <money
                  disabled
                  v-model="beneficio.valuePermited"
                  v-bind="money"
                  class="mask-input-invisible-value-permited rigth-especific margin-top-specific"
                />
              </div>
            </div>
          </td>
          <td data-label="valor pago" class="rigth-especific specific-td">
            <money
              v-model="beneficio.valorPago"
              v-bind="money"
              class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
              disabled
            ></money>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Money } from "v-money";
export default {
  name: "TableGrups",
  props: ["beneficios", "aprove", "isAlreadyClosed"],
  components: { Money },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  methods: {
    getImprimiValorPrevisto(beneficio) {
      return (
        ((beneficio.grupoCodigo == "10" ||
        beneficio.grupoCodigo == "17" ||
        beneficio.grupoCodigo == "18" ||
        beneficio.grupoCodigo == "19" ||
        beneficio.grupoCodigo == "20" ||
        beneficio.grupoCodigo == "21" ||
          (beneficio.grupoCodigo == "15" &&
            beneficio.beneficioCodigo != "02")) &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited != 0 ||
            !beneficio.hasOwnProperty("valuePermited"))) ||
        (beneficio.grupoCodigo == "15" &&
          beneficio.beneficioCodigo != "02" &&
          beneficio.seeWhenPassInCheckValueAndZero &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited == 0 ||
            !beneficio.hasOwnProperty("valuePermited"))) ||
        ((beneficio.grupoCodigo == "04" || beneficio.grupoCodigo == "05") &&
          (beneficio.beneficioCodigo == "01" ||
            beneficio.beneficioCodigo == "02") &&
          (beneficio.valuePermited != "" ||
            beneficio.valuePermited != 0 ||
            !beneficio.hasOwnProperty("valuePermited")))
      );
    },
    changevalue(beneficio) {
      this.$emit("listBeneficios", this.beneficios);
      this.$emit("getBeneficio", beneficio);
    }
  }
};
</script>

<style scoped src="./table-grups.css" ></style>
